import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import styled from '@mui/system/styled';
import CloseIcon from '@mui/icons-material/Close';
import {useDispatch} from 'react-redux';
import {closeModal} from '../../actions';

const ModalLayout = ({children}) => {
  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(closeModal());
  };

  return (
    <Box
      position="relative"
      display="flex"
      flexDirection="column"
      bgcolor="white"
      borderRadius="1rem"
      sx={{
        padding: {
          xs: '1rem',
          sm: '2.5rem',
          maxHeight: 'calc(100vh - 10rem)',
        },
      }}>
      <CloseContainer>
        <CloseButton size="small" onClick={onClose}>
          <CloseIcon fontSize="inherit" />
        </CloseButton>
      </CloseContainer>
      <Box
        display="flex"
        flexDirection="column"
        sx={{
          padding: {
            overflowY: 'scroll',
          },
        }}>
        {children}
      </Box>
    </Box>
  );
};

const CloseContainer = styled(Box)`
  position: sticky;
  top: 0;
  right: 0;
  margin-top: -1rem;
  background-color: #fff;
  display: flex;
  justify-content: flex-end;
`;

const CloseButton = styled(IconButton)`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 8px;
  border: 2px solid rgba(0, 0, 0, 0.4);
`;

export default ModalLayout;
